var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 65,
    viewBox: "0 0 69 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.68 30.84C68.68 20.41 63.59 18.69 57.94 18.46C57.07 7.35 47.82 0 34.34 0C20.86 0 11.61 7.35 10.74 18.46C5.09 18.68 0 20.41 0 30.84C0 42.29 6.13 43.25 12.41 43.25C13.38 43.25 14.16 42.46 14.16 41.5V20.19C14.16 7.88 25.03 3.52 34.34 3.52C43.65 3.52 54.52 7.89 54.52 20.19V41.5C54.52 51.85 46.84 56.58 38.86 57.82C38.06 56.11 36.35 54.92 34.34 54.92C31.58 54.92 29.34 57.16 29.34 59.92C29.34 62.68 31.58 64.92 34.34 64.92C36.6 64.92 38.49 63.4 39.11 61.34C49.97 59.8 57.18 52.96 57.94 43.22C63.59 42.99 68.68 41.27 68.68 30.84ZM10.65 39.71C6.18 39.54 3.5 38.37 3.5 30.84C3.5 23.31 6.17 22.13 10.65 21.97V39.71ZM58.02 39.71V21.97C62.49 22.14 65.17 23.31 65.17 30.84C65.17 38.37 62.5 39.55 58.02 39.71Z",
    fill: "#00E5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.e59727f90c36f954ec7dc4cae39f8a26.svg";
export { ForwardRef as ReactComponent };